export default __webpack_public_path__ + "static/Plots0014-29be7e7c3ba3b6906860c3b2f26824b1.jpg";